import React, { useState, useEffect, useRef  } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker, { DateObject } from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import TimePickerWrapper from '../../../components/Forms/Pickers/TimePicker';
import { toast } from 'react-toastify';
import axios from 'axios';

const Edit = ({ show, onClose, staffId, staffOptions, attendanceId, initialData, refresh }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const today = new DateObject();
    const [errors, setErrors] = useState({});
    const prevAttendanceTypeRef = useRef(null);
    // Find staff details
    // const staff = staffOptions.find((s) => s.id === staffId) || { name: 'Unknown', department: '-' };
    const staff = staffOptions.find((s) => s.staff_id === staffId || s.manage_staff_id === staffId) || {
        name: 'Unknown',
        department: '-',
    };
    // Map frontend Entry to backend attendance_type
    const attendance_type  = [
        { value: "0", label: 'Present' },
        { value: "1", label: 'Leave' },
        { value: "2", label: 'Permission' },
        { value: "3", label: 'On Duty' },
    ];

    // State for form fields
    const [attendanceType, setAttendanceType] = useState(null);
    const [leaveType, setLeaveType] = useState(null);
    const [leaveTypeOptions, setLeaveTypeOptions] = useState([]);
    const [date, setDate] = useState(today);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [reason, setReason] = useState('');

    // Fetch leave types from API
    useEffect(() => {
        axios
            .get(`${baseURL}/manage-leavetype`)
            .then((response) => {
                if (response.data.message === 'Leave Types fetched successfully') {
                    const options = response.data.data.map((type) => ({
                        value: type.sno,
                        label: type.leavetype_name,
                    }));
                    setLeaveTypeOptions(options);
                }
            })
            .catch((error) => {
                console.error('Error fetching leave types:', error);
            });
    }, [baseURL]);

    // useEffect(() => {
    //     if (show) {
    //         axios.get(`${baseURL}/manageattendance`)
    //             .then(res => {
    //                 if (res.data.message === "Attendance records retrieved successfully") {
    //                     // Assuming you want to find a specific attendance record by attendanceId or staffId
    //                     const attendanceRecord = res.data.data.find(record => 
    //                         record.attendance_id === attendanceId || record.manage_staff_id === staffId
    //                     );

    //                     if (attendanceRecord) {
    //                         console.log('Attendance record:', attendanceRecord);

    //                         // Then you can set your form states based on this attendanceRecord
    //                         setAttendanceType(attendance_type.find(a => a.value === String(attendanceRecord.attendance_type)) || null);
    //                         setLeaveType(leaveTypeOptions.find(l => Number(l.value) === Number(attendanceRecord.leave_type_id)) || null);
    //                         setDate(attendanceRecord.date ? new DateObject(attendanceRecord.date) : today);
    //                         setStartTime(attendanceRecord.start_time || '');
    //                         setEndTime(attendanceRecord.end_time || '');
    //                         setReason(attendanceRecord.reason || '');
    //                         // And so on, based on the data structure
    //                     }
    //                 } else {
    //                     Swal.fire('Error', 'Failed to load attendance records.', 'error');
    //                 }
    //             })
    //             .catch(err => {
    //                 console.error('Error fetching attendance:', err);
    //                 Swal.fire('Error', 'Failed to load attendance records.', 'error');
    //             });
    //     }
    // }, [show, attendanceId, staffId, leaveTypeOptions]);

    // Initialize form with initialData
    // useEffect(() => {
    //     if (initialData) {
    //         const todayKey = new DateObject().format("DD/MM (ddd)"); // "16/06 (Mon)"
    //         const dailyMap = initialData.attendance || {};
    //         const todayTypeFromMap = dailyMap[todayKey];

    //         const finalAttendanceType = typeof todayTypeFromMap !== 'undefined'
    //             ? String(todayTypeFromMap)
    //             : String(initialData.attendance_type); // fallback

    //         const foundAttendanceType = attendance_type.find(
    //             (e) => e.value === finalAttendanceType
    //         );

    //         setAttendanceType(foundAttendanceType || null);
    //         setDate(initialData.date ? new DateObject(initialData.date) : today);
    //         // setStartTime(initialData.start_time || '');
    //         // setEndTime(initialData.end_time || '');
    //         setReason(initialData.reason || '');

    //         if (finalAttendanceType === "1" && leaveTypeOptions.length > 0) {
    //             const leaveTypeId = initialData.leave_type_id || initialData.attendance?.leave_type_id || null;
    //             setLeaveType(
    //                 leaveTypeId
    //                     ? leaveTypeOptions.find((lt) => Number(lt.value) === Number(leaveTypeId))
    //                     : null
    //             );
    //         }

    //         if (["2", "3"].includes(finalAttendanceType)) {
    //             setStartTime(initialData.start_time || '');
    //             setEndTime(initialData.end_time || '');
    //         }
    //     }
    // }, [initialData, leaveTypeOptions]);

    useEffect(() => {
        if (show && leaveTypeOptions.length > 0) {
            axios.get(`${baseURL}/manageattendance`)
                .then(res => {
                    if (res.data.message === "Attendance records retrieved successfully") {
                        console.log('API paginated response:', res.data.data);
                        
                        // The actual attendance records array is inside res.data.data.data
                        const records = Array.isArray(res.data.data?.data)
                            ? res.data.data.data
                            : [];

                        const attendanceRecord = records.find(record =>
                            record.attendance_id === attendanceId || record.manage_staff_id === staffId
                        );

                        if (attendanceRecord) {
                            setAttendanceType(attendance_type.find(a => a.value === String(attendanceRecord.attendance_type)) || null);
                            setLeaveType(leaveTypeOptions.find(l => Number(l.value) === Number(attendanceRecord.leave_type_id)) || null);
                            setDate(attendanceRecord.date ? new DateObject(attendanceRecord.date) : today);
                            setStartTime(attendanceRecord.start_time || '');
                            setEndTime(attendanceRecord.end_time || '');
                            setReason(attendanceRecord.reason || '');
                        }
                    }
                })
                .catch(err => {
                    console.error('Error fetching attendance:', err);
                });
        }
    }, [show, attendanceId, staffId, leaveTypeOptions]);
    useEffect(() => {
        if (!initialData || leaveTypeOptions.length === 0) return;

        const todayKey = new DateObject().format("DD/MM (ddd)");
        const dailyMap = initialData.attendance || {};
        const todayTypeFromMap = dailyMap[todayKey];

        console.log('initialData:', initialData);
        console.log('dailyMap:', dailyMap);
        console.log('todayKey:', todayKey);
        console.log('todayTypeFromMap:', todayTypeFromMap);
        console.log('leaveTypeOptions:', leaveTypeOptions);
        console.log('Top-level leave_type_id:', initialData.leave_type_id);

        let leaveTypeId = null;
        let reasonValue = '';
        let attendanceTypeValue = null;

        if (todayTypeFromMap && typeof todayTypeFromMap === 'object') {
            leaveTypeId = todayTypeFromMap.leave_type_id || null;
            reasonValue = todayTypeFromMap.reason || '';
            attendanceTypeValue = String(todayTypeFromMap.type ?? '');
        } else {
            // If it's not an object, treat it as the attendance type value directly
            attendanceTypeValue = String(todayTypeFromMap);
            leaveTypeId = initialData.leave_type_id || null;  // fallback to top-level
            reasonValue = initialData.reason || '';
        }

        const foundAttendanceType = attendance_type.find(
            e => e.value === attendanceTypeValue
        );

        setAttendanceType(foundAttendanceType || null);
        setReason(reasonValue);

        if (attendanceTypeValue === "1" && leaveTypeOptions.length > 0) {
            setLeaveType(
                leaveTypeId
                    ? leaveTypeOptions.find(lt => Number(lt.value) === Number(leaveTypeId))
                    : null
            );
        }

        if (foundAttendanceType && ["2", "3"].includes(foundAttendanceType.value)) {
            setStartTime(initialData.start_time || '');
            setEndTime(initialData.end_time || '');
        }
    }, [initialData, leaveTypeOptions]);

    useEffect(() => {
        if (!prevAttendanceTypeRef.current) {
            // First load — don't clear anything
            prevAttendanceTypeRef.current = attendanceType?.value;
            return;
        }

        const prevType = prevAttendanceTypeRef.current;
        const currentType = attendanceType?.value;

        // Only run logic if the type actually changed
        if (prevType !== currentType) {
            setErrors({});

            if (currentType === "0") {
                setReason('');
                setLeaveType(null);
                setStartTime('');
                setEndTime('');
            } else if (currentType === "1") {
                setStartTime('');
                setEndTime('');
                setReason('');
            } else if (currentType === "2" || currentType === "3") {
                setLeaveType(null);
                setReason('');
                setStartTime('');
                setEndTime('');
            }

            prevAttendanceTypeRef.current = currentType;
        }
    }, [attendanceType]);


    // const format = "MM/DD/YY";


    // const [selectedOption, setSelectedOption] = useState(today); // set default to today
    // const [Option, setOption] = useState(null);  // store selected option object

    // Handle form submission
    const handleSubmit = async () => {
        const newErrors = {};

        if (!attendanceType) {
            newErrors.attendanceType = "This Field is required";
        }

        if (attendanceType?.value === "1") { // Leave
            if (!leaveType) newErrors.leaveType = "This Field is required";
            if (!reason) newErrors.reason = "This Field is required";
        }

        if (attendanceType?.value === "2" || attendanceType?.value === "3") { // Permission or On Duty
            if (!startTime) newErrors.startTime = "This Field is required";
            if (!endTime) newErrors.endTime = "This Field is required";
            if (!reason) newErrors.reason = "This Field is required";
        }

        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;

        const attendanceData = {
            attendance_id: attendanceId,
            manage_staff_id: staffId,
            attendance_type: Number(attendanceType.value),
            date: date.format('YYYY-MM-DD'),
            reason: reason || undefined,
        };

        if (attendanceType.value === '1') {
            // Leave
            // if (!leaveType) {
            //     Swal.fire('Error', 'Please select a leave type.', 'error');
            //     return;
            // }
            attendanceData.leave_type = leaveType.value;
        } 
        else if (attendanceType.value === '2' || attendanceType.value === '3') {
            // Permission or On Duty
            // if (!startTime || !endTime) {
            //     Swal.fire('Error', 'Please provide start and end times.', 'error');
            //     return;
            // }
            attendanceData.start_time = startTime;
            attendanceData.end_time = endTime;
            if (attendanceType.value === '2') {
                attendanceData.permision_absent = initialData?.permision_absent || null;
                attendanceData.future_permission = initialData?.future_permission || null;
            }
        }

        try {
            const response = await axios.put(
                `${baseURL}/manageattendance/list/${staffId}`,
                {
                    attendances: [attendanceData], 
                }
            );
            if (response.data.message === 'Attendance updated successfully from list page') {
                toast.success("Attendance updated successfully!");  // <-- toast success message
                onClose();
                refresh();
            } 
        } catch (error) {
            console.error('Error updating attendance:', error);
            toast.error("Failed to update attendance.");  // <-- toast error message
            // Swal.fire('Error', 'Failed to update attendance.', 'error');
        }
    };


    return (
        <Modal show={show} size="md">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Attendance</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Staff</label>
                            <label className='text-black fs-6 font-w500'>{staff.name}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Department</label>
                            <label className='text-black fs-6 font-w500'>{staff.department}</label>
                        </div>

                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Date</label>
                            <label className='text-danger fs-6 font-w500'>{date.format('DD-MMMM-YYYY')}</label>
                        </div>
                    </div>

                    <div className="col-lg-12 mb-2">
                        <label className="text-black font-w500 fs-7">
                            Entry<span className="required">*</span>
                        </label>
                        <Select
                            placeholder="Select Attendance"
                            value={attendanceType}
                            onChange={setAttendanceType}
                            options={attendance_type}
                        />
                        {errors.attendanceType && <div className="text-danger fs-8 mt-1">{errors.attendanceType}</div>}
                    </div>

                    {(attendanceType?.value === "1") && (
                        <div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Leave Type<span className="required">*</span></label>
                                <Select placeholder='Select Leave Type'
                                    value={leaveType}
                                    onChange={setLeaveType}
                                    options={leaveTypeOptions}
                                />
                                {errors.leaveType && <div className="text-danger fs-8 mt-1">{errors.leaveType}</div>}
                            </div>
                        </div>
                    )}

                    {(attendanceType?.value === "2" || attendanceType?.value === "3") && (
                        <div className='row'>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">
                                    Start Time <span className="required">*</span>
                                </label>
                                <div className='me-n7'>
                                    <TimePickerWrapper
                                        value={startTime}
                                        onChange={(time) => setStartTime(time)}
                                    />
                                </div>
                                {errors.startTime && <div className="text-danger fs-7 mt-1">{errors.startTime}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">
                                    End Time <span className="required">*</span>
                                </label>
                                <div className='me-n7'>
                                    <TimePickerWrapper
                                        value={endTime}
                                        onChange={(time) => setEndTime(time)}
                                    />
                                </div>
                                {errors.endTime && <div className="text-danger fs-7 mt-1">{errors.endTime}</div>}
                            </div>
                        </div>
                    )}
                    {(attendanceType?.value !== "0") && (
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Reason<span className="required">*</span></label>
                            <textarea rows={3} className="h-auto form-control" name="comment" placeholder="Reason" value={reason}
                                onChange={(e) => setReason(e.target.value)} />
                                {errors.reason && <div className="text-danger fs-8 mt-1">{errors.reason}</div>}
                        </div>
                    )}
                </div>
                <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                    <button type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</button>
                    <button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Update Attendance</button>
                </div>
            </div>
        </Modal >
    );
};

export default Edit;
